import { getAnalytics, logEvent } from "firebase/analytics";
import { app } from './firebaseConfig';

const analytics = getAnalytics(app);

const analyticsEvent = (event, params) => {
  logEvent(analytics, event, params)
}

export default analyticsEvent;